import { Component, HostListener, Input, OnDestroy, OnInit } from "@angular/core";

@Component({
  selector: 'planningactions-contextmenu',
  templateUrl: './planningactions-contextmenu.component.html'
})
export class PlanningactionsContextmenuComponent implements OnInit, OnDestroy {
  // Public API
  @Input() label: string = '';
  /** CSS selector of the container within which right-click opens the menu. */
  @Input() activatorSelector: string = '#planning-page-details';
  /** Adjust X offset if needed to align the dropdown (matches previous behavior). */
  @Input() xOffset: number = -70;
  /** Allow native menu when holding Ctrl/Command */
  @Input() allowModifierBypass = true;

  // Planning selection inputs to drive the shared menu
  @Input() selectionType: any;
  @Input() selectedTransportOrders: any[] | undefined;
  @Input() selectedPlanningBlocks: any[] | undefined;
  @Input() selectedOrderLines: any[] | undefined;

  // Internal state
  visible = false;
  x = 0;
  y = 0;

  ngOnInit(): void {}
  ngOnDestroy(): void {}

  private getActivatorElements(): NodeListOf<HTMLElement> {
    try {
      return document.querySelectorAll(this.activatorSelector);
    } catch {
      return document.querySelectorAll('#planning-page-details');
    }
  }

  private isInsideActivator(target: EventTarget | null): boolean {
    if (!(target instanceof Node)) {
      return false;
    }
    const activators = this.getActivatorElements();
    for (let i = 0; i < activators.length; i++) {
      const el = activators[i];
      if (el && el.contains(target)) {
        return true;
      }
    }
    return false;
  }

  @HostListener('document:contextmenu', ['$event'])
  onDocumentContextMenu(event: MouseEvent) {
    // If modifiers pressed, bypass to native menu
    if (this.allowModifierBypass && (event.ctrlKey || event.metaKey)) {
      this.close();
      return;
    }

    if (this.isInsideActivator(event.target)) {
      event.preventDefault();
      // viewport-based position
      this.x = (event.clientX || 0) + (this.xOffset || 0);
      this.y = (event.clientY || 0);
      this.visible = true;
    } else {
      // Outside activator → let the native menu show and ensure ours is closed
      this.close();
    }
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.close();
  }

  @HostListener('document:scroll')
  onDocumentScroll() {
    this.close();
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(e: KeyboardEvent) {
    if (e && (e.key === 'Escape' || e.key === 'Esc')) {
      this.close();
    }
  }

  close() {
    if (this.visible) {
      this.visible = false;
    }
  }
}
